import { ASTWithName } from '@angular/compiler';
import { Injectable } from '@angular/core';
// import { throwMatDialogContentAlreadyAttachedError } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CognitoUser, CognitoUserPool, CognitoUserSession } from 'amazon-cognito-identity-js';
import { BehaviorSubject, EmptyError, Observable, observable, of, Subject } from 'rxjs';
import { delay, timeInterval } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';
import { DBService } from './DB.service';
import { callbackify } from 'util';
import { signIn, confirmSignIn, signOut, getCurrentUser, fetchAuthSession, resetPassword,
         fetchUserAttributes, confirmResetPassword, updatePassword } from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthNewService {
  user = new Subject<CognitoUser>();
  currentUser!: CognitoUser;
  passwordChanged = new BehaviorSubject<boolean>(false);
  forgotPasswordCode = new BehaviorSubject<boolean>(false);
  forgotPasswordMessage = new BehaviorSubject<string>('');
  userGroup = new BehaviorSubject('');
  groups;
  forgotMessage;
  currentEmail: string;
  currentUsername: string;
  signinError = new Subject<string>();
  getCurrentLoginUser = new Subject<CognitoUser>();
  private userPool = new CognitoUserPool(environment.userPool);

  constructor(private router: Router,
    private storageService: StorageService,
    private dbService: DBService) { }


  // function to signin
  async handleSignIn(username: string, password: string) {
    try {
      const { isSignedIn, nextStep } = await signIn({username, password});
      if (
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_EMAIL_CODE" ||
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE" ||
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
      ) {
        return {Status: "MFA"};
      } else if ( nextStep.signInStep === "RESET_PASSWORD" ) {
        return {Status: "NEW_PASSWORD"};
      } else if ( nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
        return {Status: "NEW_PASSWORD"}
      } else {
        if ( isSignedIn ) {
          const userAttributes = await fetchUserAttributes();
          if (userAttributes) {
            const access = userAttributes['custom:access'];
            if (access) {
              sessionStorage.setItem('access', access);
            }
            this.setUserData();
          }
            return {Status: "SUCCESS"};
        } else {
//           console.log("Unhandled case from signin call:");
//           console.log(nextStep.signInStep);
          return {Status: "UNHANDLED"};
        }
      }
    } catch (error) {
      this.signinError.next(error);
      return {Status: "ERROR"};
    }
  }

//   signIn(username: string, password: string) {
//     Auth.signIn(username, password)
//     .then((user: any) => {
//       // console.log('user print in service', user)
//       this.currentUser = user;
//           if (user.attributes !== undefined) {
//               this.storageService.set('username', user['username']);
//               this.storageService.set('organization', user['attributes']['custom:organization']);
//               this.storageService.set('group', user['attributes']['custom:group']);
//               this.storageService.set('access', user['attributes']['custom:access']);
//               this.storageService.set('fullname', user['attributes']['name']);
//           }
//       this.user.next(user);
//       this.setUserData();
//     })
//     .catch((error) => {
//
//       this.signinError.next(error);
//
//     })
//
//   }

  async handleConfirmCode(code:string) {
    try {
      const { isSignedIn, nextStep } = await confirmSignIn({challengeResponse: code});
      return { isSignedIn, nextStep };
    } catch (error) {
      return { isSignedIn:false, nextStep:"Error"};
    }
  }

//   confirmCode(code: string) {
//     // console.log(this.currentUser);
//     Auth.confirmSignIn(this.currentUser, code)
//     .then((data: any) => {
//       this.user.next(data);
//     })
//     .catch((error) => {
//       // console.log(error);
//     })
//   }

  async newPassword(newPassword:string) {
    try {
      await confirmSignIn({challengeResponse:newPassword});
      this.passwordChanged.next(true);
    } catch(error) {
//       console.log(error);
    }
  }

  // function to handle new password
//   newPassword (password) {
//     Auth.completeNewPassword(this.currentUser, password)
//     .then((res) => {
//       // console.log(res);
//       this.passwordChanged.next(true);
//     })
//     .catch((error) => {
//       // console.log(error);
//     })
//   }

  // function to get the current user

  async getAuthenticatedUser() {
    const user = await getCurrentUser();
    return user;
  }

//   getCurrentUser(User?) {
//
//     Auth.currentSession();
//     // const user=Auth.currentSession().then(res =>
//     //   {
//     //     return res.getAccessToken().payload.sub;
//     //   }
//     //   );
//   //  console.log(Auth.currentSession());
//
//     Auth.currentAuthenticatedUser({
//       bypassCache: true
//     }).then(user => {
//       this.getCurrentLoginUser.next(user);
//     })
//     .catch(err => {
//       return err
//     });
//
//     }

  // function to signout
  async handleSignout() {
    await signOut();
    this.router.navigate(['']);
  }

//   signout () {
//     Auth.currentAuthenticatedUser({
//       bypassCache: true
//     })
//     .then(user => {
//       if (user) {
//         try {
//           this.user.next(null);
//           Auth.signOut({global: true})
//         } catch (error) {
//           console.log('error occured while logout', error);
//         }
//         this.router.navigate(['']);
//       }
//     })
//     .catch(err => console.log(err));
//   }

  // function to handle forget password
  // Send confirmation code to user's email
  async forgetPassword(username:string) {
    try {
      const result = await resetPassword({username});
//       console.log(result);
      this.forgotPasswordCode.next(true);
    } catch(error) {
//       console.log(error);
    }
  }

//   forgetPassword(username: string) {
//     Auth.forgotPassword(username)
//     .then((data) => {
//       console.log(data)
//       this.forgotPasswordCode.next(true);
//     })
//     .catch((err) => console.log(err))
//   }

  // Collect confirmation code and new password
  async forgetPasswordConfirm(username, code, password) {
    try {
      await confirmResetPassword({username: username, newPassword: password, confirmationCode: code});
      this.forgotMessage = 'Password Changed';
    } catch(error) {
//       console.log(error);
      this.forgotMessage = 'Error';
    }
    setTimeout(() => {
      this.forgotPasswordMessage.next(this.forgotMessage);
    }, 2000);

  }

//   forgetPasswordConfirm (username, code, password) {
//     Auth.forgotPasswordSubmit(username, code, password)
//     .then((res) => {
//       if (res === 'SUCCESS' ) {
//         this.forgotMessage = 'password changed'
//       } else {
//         this.forgotMessage = 'Error occurred'
//       }
//     })
//     .catch((error) => {
//       this.forgotMessage = error.message
//     })
//     setTimeout(() => {
//       this.forgotPasswordMessage.next(this.forgotMessage);
//     }, 2000);
//   }

//   getAuthenticatedUser() {
//     return this.userPool.getCurrentUser();
//   }

  // Use code from OIDC to fetch user pool tokens
  async getTokensWithCode(code) {
    const requestParams = new URLSearchParams({
      grant_type: "authorization_code",
      client_id: environment.userPool.ClientId,
      redirect_uri: environment.redirectUrl,
      code: code
    });

    try {
      const response = await fetch(environment.tokenEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: requestParams
      });

      if (!response.ok) {
        console.log("Token endpoint call failed");
      }

      const tokens = await response.json();

      return {
        accessToken: tokens.access_token,
        idToken: tokens.id_token,
        refreshToken: tokens.refresh_token,
        tokenType: tokens.token_type,
        expiresIn: tokens.expires_in
      };
    } catch (error) {
      console.log("Error when calling getTokensWithCode");
      return;
    }
  }

  // Save tokens in local storage so that Amplify works
  setAmplifySession(tokens) {
    const payload = JSON.parse(atob(tokens.idToken.split('.')[1]));
//     console.log(payload);
    const username = payload['cognito:username'] || payload.sub;
//     console.log(username);

    const clientId = environment.userPool.ClientId;
    const keyPrefix = `CognitoIdentityServiceProvider.${clientId}`;

    localStorage.setItem(`${keyPrefix}.LastAuthUser`, username);
    localStorage.setItem(`${keyPrefix}.${username}.accessToken`, tokens.accessToken);
    localStorage.setItem(`${keyPrefix}.${username}.idToken`, tokens.idToken);
    localStorage.setItem(`${keyPrefix}.${username}.refreshToken`, tokens.refreshToken);

  }

  async setUserData() {
    const userAttributes = await fetchUserAttributes();
//     console.log("User Attributes retrieved:");
//     console.log(userAttributes);
    this.currentEmail = userAttributes.email;
    this.currentUsername = this.currentEmail.split('@')[0];
    this.storageService.set('userPrefix', this.currentUsername);
    const user = await getCurrentUser();
    this.storageService.set('username', user.username);

    // Retrieve user's access, group, and org from backend
    this.dbService.getUserData(this.currentUsername).subscribe({
        next: data => {
//             console.log(data);
            this.storageService.set('access', data['access_id']);
            this.storageService.set('group', data['group_id']);
            this.storageService.set('org', data['org_id']);
            this.storageService.set('fullname', data['full_name']);
        },
        error: err => {
//             console.log(err);
        }
    });
  }

}
